<template lang="pug">
  .component-input-form.row
    .column(v-for="(field, index) in fields")
      .input-group
        input.input-group-field(type="text", :placeholder="placeholders && placeholders[index] ? placeholders[index] : field", @keyup.enter="updatedData", v-model="data[field]")
        span.input-group-label(@click="updatedData")
          span.fa.fa-search
</template>
<script type="text/babel">

  export default {
    name: "InputForm",
    components: {},
    data() {
      return {
        // Empty container object
        data: {},
        deboucedEmitter: null
      }
    },
    created() {
      this.deboucedEmitter = this.$debounce(() => {
        this.$emit('updatedData', this.data)
      }, 350)
    },
    methods: {
      updatedData() {
        // Delete empty fields
        for (var field in this.data) {
          if (this.data[field] === null || this.data[field] === undefined || this.data[field] === "") {
            delete this.data[field];
          }
        }

        this.deboucedEmitter()
      },
    },
    props: {
      fields: {
        type: Array,
        required: true
      },
      placeholders: {
        type: Array,
        required: false
      },
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .toggle
    display: none
</style>



// WEBPACK FOOTER //
// InputForm.vue?3131af9e